import * as angular from 'angular';
import { IRequestService } from '../request.service';
import { RawData } from '../../models';
import { ValueReadResult } from './ValueReadResult';

export interface IrawValuesService {
    getRawData(guids: string[], beginDate: string, endDate: string): angular.IPromise<ValueReadResult>;
}

export class RawValuesService implements IrawValuesService {
    static serviceId: string = 'rawValuesService';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {}

    getRawData(guids: string[], beginDate: string, endDate: string): angular.IPromise<ValueReadResult> {
        return this._requestService.postAtV1('rawValues/getRaw', guids, {
            beginDateTime: beginDate,
            endDateTime: endDate
        });
    }
}
